
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"deposit"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M256 280.69c-75.65 0-137.19-61.54-137.19-137.19S180.35 6.3 256 6.3s137.19 61.55 137.19 137.2S331.65 280.69 256 280.69zm0-239.39a102.2 102.2 0 10102.19 102.2A102.31 102.31 0 00256 41.3z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M249.09 199.21c-21.37-1.88-36.93-13-37.71-33.31H240c.63 6.44 3.77 10.37 9.12 12.1v-24.83c-16.82-4.4-37.87-9.11-37.87-33.78 0-19.64 16.5-31.27 37.87-32.69V74h10v12.7c21.53 1.73 35.36 12.73 36.77 32.69h-28.73c-.63-5.82-3.62-9.43-8-11v24.35c16.82 4.72 38.34 9.28 38.34 33.63 0 17-13.51 31.9-38.34 33v12.73h-10zm0-69.77V107.6c-5.82 1-9.43 4.4-9.43 10.53 0 5.5 3.77 8.8 9.43 11.31zm10 26.72v22.31c6.29-1.1 10.22-5.34 10.22-11.16.05-5.65-4.04-8.79-10.17-11.15zM407.19 509H52a29.54 29.54 0 01-29.5-29.5V286.27a29.53 29.53 0 0129.5-29.5h355.19a29.53 29.53 0 0129.5 29.5v37.24h-35v-31.74H57.51V474h344.18v-32h35v37.5a29.54 29.54 0 01-29.5 29.5z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M82.84 314.38h35v136.96h-35zM460 459.44h-87.66a29.53 29.53 0 01-29.5-29.5v-94.43a29.53 29.53 0 0129.5-29.5H460a29.53 29.53 0 0129.5 29.5v94.43a29.53 29.53 0 01-29.5 29.5zm-82.15-35h76.65V341h-76.66z"}})])])
          )
        }
      }
    